




























import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../../shared/services/mixin";
import {Component, Prop, PropSync} from "vue-property-decorator";
import {DebtCustomer, DebtEmployee, DebtPostOffice} from "@/interfaces/entity";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import LadingPaymentTypeLabel from "../../../../../ladings/List/components/PaymentTypeLabel.vue";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 80
    },
    {
        title: "Mã vận đơn",
        dataIndex: "billLading.ladingCode",
        key: "ladingCode",
        width: 150,
        ellipsis: true
    },
    {
        title: "Thu hộ COD",
        dataIndex: "billLading.codMoney",
        key: "COD",
        scopedSlots: {customRender: 'codMoney'},
        width: 150,
        ellipsis: true
    },
    {
        title: "Tổng cước",
        dataIndex: "billLading.totalFee",
        key: "totalMoney",
        scopedSlots: {customRender: 'totalFee'},
        width: 150,
        ellipsis: true
    },
    {
        title: "Thu tiền NN",
        dataIndex: "billLading.receiverCollect",
        key: "receiverCollect",
        scopedSlots: {customRender: 'receiverCollect'},
        width: 150,
        ellipsis: true
    },
    {
        title: "HT Thanh toán",
        dataIndex: "billLading.payment",
        key: "payment",
        scopedSlots: {customRender: 'payment'},
        width: 150,
        ellipsis: true
    },
    {
        title: "Tổng thu",
        dataIndex: "money",
        key: "money",
        scopedSlots: {customRender: 'money'},
        width: 150,
        ellipsis: true
    },
];
@Component({
    name: "ReceiptDebtEmployeeTable",
    components: {LadingPaymentTypeLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly debtEmployees!: Array<DebtEmployee>;
    @PropSync('debtIds', {default: () => [], type: Array}) syncDebtIds!: number[];
    columns = columns;

    onSelectedIdsChange(selectedIds: any) {
        this.syncDebtIds = selectedIds;
    }
}
